import { graphql } from "babel-plugin-relay/macro";
import React from "react";
import { useLazyLoadQuery } from "react-relay";
import { MaintenanceScreen_Query } from "../../__generated__/MaintenanceScreen_Query.graphql";
import { AllNodesExportTriggerComponent } from "../components/all-nodes-export-trigger";
import { AllPointsExportTriggerComponent } from "../components/all-points-export-trigger";
import { MaintenanceToggleButton } from "../components/maintenance/MaintenanceToggleButton";

const QUERY = graphql`
	query MaintenanceScreen_Query {
		Maintenance {
			MaintenanceUpdate {
				id
				...MaintenanceToggleButton_Fragment
			}
		}
	}
`;

export const MaintenanceScreen = () => {
	const data = useLazyLoadQuery<MaintenanceScreen_Query>(
		QUERY,
		{},
		{ fetchPolicy: "network-only" },
	);
	return (
		<div>
			<div className="flex justify-content-center">
				<MaintenanceToggleButton userFragmentRef={data.Maintenance.MaintenanceUpdate} />
			</div>
			{/*	<div className="flex justify-content-center">
			<AllNodesExportTriggerComponent/>
			</div>
			<div className="flex justify-content-center">
				<AllPointsExportTriggerComponent/>
			</div>*/}
		</div>
	);
};
